import Vue, { createApp } from "vue";
import "../assets/common.less";

import { FundingAcknowledgment, IconButton, CreditLogos, UserExperience } from "@cosmicds/vue-toolkit";
import Radwave from "./Radwave.vue";
import CDSPrivacyPolicy from "./CDSPrivacyPolicy.vue";

import vuetify from "../plugins/vuetify";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { WWTComponent, wwtPinia } from "@wwtelescope/engine-pinia";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBookOpen,
  faPause,
  faPlay,
  faTimes,
  faVideo,
  faHouse,
} from "@fortawesome/free-solid-svg-icons";

library.add(faBookOpen);
library.add(faPause);
library.add(faPlay);
library.add(faTimes);
library.add(faVideo);
library.add(faHouse);

/** v-hide directive taken from https://www.ryansouthgate.com/2020/01/30/vue-js-v-hide-element-whilst-keeping-occupied-space/ */
// Extract the function out, up here, so I'm not writing it twice
const update = (el: HTMLElement, binding: Vue.DirectiveBinding) => el.style.visibility = (binding.value) ? "hidden" : "";

createApp(Radwave, {
  wwtNamespace: "radwave-in-motion"
})
 
  // Plugins
  .use(wwtPinia)
  .use(vuetify)

  // Directives
  .directive(
    /**
    * Hides an HTML element, keeping the space it would have used if it were visible (css: Visibility)
    */
    "hide", {
      // Run on initialisation (first render) of the directive on the element
      beforeMount(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      },
      // Run on subsequent updates to the value supplied to the directive
      updated(el, binding, _vnode, _prevVnode) {
        update(el, binding);
      }
    })

  // Components
  .component("WorldWideTelescope", WWTComponent)
  .component('font-awesome-icon', FontAwesomeIcon)
  .component('icon-button', IconButton)
  .component('funding-acknowledgement', FundingAcknowledgment)
  .component('credit-logos', CreditLogos)
  .component('user-experience', UserExperience)
  .component('cds-privacy-policy', CDSPrivacyPolicy)

  // Mount
  .mount("#app");
